import {Box} from '@mui/material';
import {useWindowSize} from '@react-hook/window-size';
import type * as React from 'react';
import {useEffect, useRef} from 'react';
import {UncontrolledReactSVGPanZoom} from 'react-svg-pan-zoom';

type Props = {
    children: React.ReactElement;
};

const PanZoomWrapper: React.FC<Props> = ({children}: Props) => {
    const [width, height] = useWindowSize({initialWidth: 400, initialHeight: 400});
    const refObject: React.LegacyRef<UncontrolledReactSVGPanZoom> | undefined | null = useRef(null);

    useEffect(() => {
        if (refObject.current) {
            refObject.current.fitToViewer();
        }
    }, []);

    return (
        <Box style={{width: '100%', height: '100%'}}>
            <UncontrolledReactSVGPanZoom
                ref={refObject}
                width={width - 30}
                height={height - 100}
                background={'#fff'}
                scaleFactorMax={3}
                scaleFactorMin={0.7}
                detectAutoPan={false}
                defaultTool={'pan'}
                miniatureProps={{
                    position: 'none',
                    background: '#fff',
                    width: 100,
                    height: 80,
                }}
                toolbarProps={{
                    position: 'none',
                }}
            >
                <svg viewBox='0 0 1200 800' width={1200} height={800}>
                    <title id='card-display'>Card Display</title>
                    {children}
                </svg>
            </UncontrolledReactSVGPanZoom>
        </Box>
    );
};

export default PanZoomWrapper;
